interface JwtPayload {
    exp?: number;
    userID?: number | string;
    [key: string]: unknown;
}

export function decodeJwtPayload(token: string): JwtPayload | null {
    if (!token) return null;

    try {
        const parts = token.split('.');
        if (parts.length < 2) return null;

        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

        return JSON.parse(atob(padded)) as JwtPayload;
    } catch {
        return null;
    }
}

export function isTokenExpired(token: string, skewSeconds = 0): boolean {
    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.exp !== 'number') return false;

    return payload.exp * 1000 <= Date.now() + skewSeconds * 1000;
}
